<div class="container-fluid">
  <div>
    <div class="header">
      {{editing ? ('bikeshop.rentals.products.edit_product' | translate) : ('bikeshop.rentals.products.add_product' |
      translate)}}
      {{editing && !loading ? " - " + product.brand + " " + product.model : ""}}
    </div>
  </div>
</div>

<div *ngIf="loading" style="margin-top: 64px;display: flex;justify-content: center;">
  <p-progressSpinner [style]="{ width: '30px', height: '30px' }" animationDuration=".5s">
  </p-progressSpinner>
</div>

<div class="container-fluid" *ngIf="!loading && editing && product && product.id">
  <p-tabMenu *ngIf="menuChanged" [model]="tabs" [activeItem]="activeItem"></p-tabMenu>
</div>

<div class="container-fluid" style="padding-bottom: 64px;" *ngIf="!loading && selectedTab===0">
  <div>
    <div class="info-container content">
      <div class="row" *ngIf="editing">
        <div class="col-md-4 label">
          {{ 'bikeshop.rentals.products.serial_number' | translate }}:
        </div>
        <div class="col-md-8 value">
          {{product.serialNumber}}
        </div>
      </div>
      <div class="row margin-top-8">
        <div class="col-md-4 label" [ngClass]="{'red bold': product.categoryID === 0 }">
          {{ 'bikeshop.rentals.products.category' | translate }}:
        </div>
        <div class="value" [ngClass]="{'col-md-8': editing, 'col-md-7': !editing}">
          <p-dropdown [options]="categoryOptions" [(ngModel)]="product.categoryID" [disabled]="cloneProduct">
          </p-dropdown>
        </div>
        <div class="col-md-1 value" *ngIf="!editing">
          <span class="fa fa-plus-circle" (click)="addCategory()"
            pTooltip="{{'bikeshop.rentals.category.add_category' | translate}}"></span>
        </div>
      </div>

      <div class="row margin-top-8">
        <div class="col-md-4 label" [ngClass]="{'red bold': product.brand === undefined || product.brand.length === 0}">
          {{ 'bikeshop.rentals.products.brand' | translate }}:
        </div>
        <div class="col-md-8 value">
          <input type="text" pInputText placeholder="{{'bikeshop.rentals.products.brand_placeholder' | translate}}"
            [(ngModel)]="product.brand" [disabled]="cloneProduct" />
        </div>
      </div>

      <div class="row margin-top-8">
        <div class="col-md-4 label" [ngClass]="{'red bold': product.model === undefined || product.model.length === 0}">
          {{ 'bikeshop.rentals.products.model' | translate }}:
        </div>
        <div class="col-md-8 value">
          <input type="text" pInputText placeholder="{{'bikeshop.rentals.products.model_placeholder' | translate}}"
            [(ngModel)]="product.model" [disabled]="cloneProduct" />
        </div>
      </div>

      <div class="row margin-top-8">
        <div class="col-md-4 label"
          [ngClass]="{'red bold': product.yearModel === undefined || product.yearModel.length === 0}">
          {{ 'bikeshop.rentals.products.year' | translate }}:
        </div>
        <div class="col-md-2 value">
          <input type="number" maxlength="4" max="9999" min="0" pInputText [(ngModel)]="product.yearModel"
            [disabled]="cloneProduct" />
        </div>
      </div>

      <div class="row margin-top-8">
        <div class="col-md-4 label">
          {{ 'bikeshop.rentals.products.color' | translate }}:
        </div>
        <div class="col-md-8 value">
          <input type="text" pInputText placeholder="{{'bikeshop.rentals.products.color_placeholder' | translate}}"
            [(ngModel)]="product.color" maxlength="20" />
        </div>
      </div>
    </div>

    <div class="info-container content"
      *ngIf="productServiceIndicatorConfig && productServiceIndicatorConfig.serviceIndicatorsConfigured">
      <div class="row" *ngIf="productServiceIndicatorConfig.linkType === 'NONE'">
        <div class="col-md-12"><small class="bold">{{ 'bikeshop.rentals.products.service_indicator_not_linked' |
            translate }}</small></div>
      </div>
      <div class="row" *ngIf="productServiceIndicatorConfig.linkType === 'CATEGORY'">
        <div class="col-md-12"><small class="bold">{{ 'bikeshop.rentals.products.linked_via_category' | translate
            }}</small></div>
      </div>


      <div class="row margin-top-8">
        <div class="col-md-4 label">
          {{ 'bikeshop.rentals.products.link_to_specific_service_indicator' | translate }}:
        </div>
        <div class="col-md-8 value">
          <div><p-dropdown [options]="serviceIndicators" [(ngModel)]="productServiceIndicatorConfig.serviceIndicatorID"
              (onChange)="updateProductServiceIndicatorLink($event)"></p-dropdown></div>
        </div>
      </div>

      <div *ngIf="isServiceDue">
        <div class="row margin-top-16">
          <div class="col-md-12 label red bold">{{ "bikeshop.rentals.products.service_due" | translate}}</div>
        </div>
        <div class="row">
          <div class="col-md-12 label red">{{ "bikeshop.rentals.products.service_due_description" | translate}}</div>
        </div>
      </div>
    </div>

    <div class="info-container content" *ngIf="!editing">
      <div class="row">
        <div class="col-md-4 label"
          [ngClass]="{'red bold': product.quantityToCreate <= 0 || product.quantityToCreate === ''}">
          {{ 'bikeshop.rentals.products.quantity_to_create' | translate }}:
        </div>
        <div class="col-md-2 value">
          <input type="number" pInputText [(ngModel)]="product.quantityToCreate" (change)="updateSerialNumberArray()" />
        </div>
      </div>
    </div>

    <div class="info-container content">
      <div class="row">
        <div class="col-md-4 label">
          {{ 'bikeshop.rentals.products.size' | translate }}:
        </div>
        <div class="col-md-4 value">
          <p-dropdown [options]="sizeOptions" [(ngModel)]="product.size" [editable]="true">
          </p-dropdown>
        </div>
      </div>

      <div class="row margin-top-8">
        <div class="col-md-4 label">
          {{ 'bikeshop.rentals.products.size_description' | translate }}:
        </div>
        <div class="col-md-8 value">
          <input type="text" pInputText
            placeholder="{{'bikeshop.rentals.products.size_description_placeholder' | translate}}"
            [(ngModel)]="product.sizeDescription" />
        </div>
      </div>
    </div>

    <div class="info-container content">
      <div class="row">
        <div class="col-md-4 label">
          {{ 'bikeshop.rentals.products.initial_value' | translate }}:
        </div>
        <div class="col-md-4 value">
          <div class="p-inputgroup">
            <span class="p-inputgroup-addon">{{partnerData.CurrencySymbol}}</span>
            <input type="number" pInputText (input)="onInitialValueChange()" (blur)="onInitialValueChange()"
              [(ngModel)]="product.initialValue">
          </div>

        </div>
      </div>
      <!-- <div class="row margin-top-8">
        <div class="col-md-4 label">
          {{ 'bikeshop.rentals.products.activate_date' | translate }}
        </div>
        <div class="col-md-4 value">
          <p-calendar [(ngModel)]="product.activatedDate" dateFormat="{{countryData.DatePickerFormat}}"
            [showTime]="false"></p-calendar>
        </div>
      </div> -->
    </div>

    <div class="info-container content">
      <div class="row">
        <div class="col-md-4 label margin-top-0">
          {{ 'bikeshop.rentals.products.bike_description' | translate }}:
        </div>
        <div class="col-md-8 value">
          <quill-editor [(ngModel)]="product.description" [style]="{'height':'280px'}" [modules]="modules" format="html"
            placeholder="{{ 'bikeshop.rentals.products.bike_description_placeholder' | translate}}">
          </quill-editor>
        </div>
      </div>
    </div>

    <div class="info-container content" *ngIf="editing">
      <div class="row">
        <div class="col-md-4 label">
          {{ 'bikeshop.rentals.products.serial_number' | translate }}:
        </div>
        <div class="col-md-8 value">
          <input type="text" pInputText
            placeholder="{{'bikeshop.rentals.products.serial_number_placeholder' | translate}}"
            [(ngModel)]="product.serialNumber" />
        </div>
      </div>

      <!-- <div class="row margin-top-8">
        <div class="col-md-4 label">
          {{ 'bikeshop.rentals.products.printable_serial_number' | translate }}:
        </div>
        <div class="col-md-8 value">
          <input type="text" pInputText
            placeholder="{{'bikeshop.rentals.products.printable_serial_number_placeholder' | translate}}"
            [(ngModel)]="product.printableSerialNumber" />
        </div>
      </div> -->
    </div>

    <div class="info-container content" *ngIf="!editing">
      <div *ngFor="let serialNumber of serialNumbers; let i = index">
        <div class="row" [ngClass]="{'margin-top-8': i > 0}">
          <div class="col-md-4 label">
            {{ 'bikeshop.rentals.products.serial_number' | translate }} #{{i + 1}}:
          </div>
          <div class="col-md-8 value">
            <input type="text" pInputText [(ngModel)]="serialNumbers[i].serialNumber" />
          </div>
        </div>
      </div>
    </div>

    <div class="info-container content">
      <div class="row">
        <div class="col-md-4 label" [ngClass]="{'red bold': product.priceGroupID === 0 }">
          {{ 'bikeshop.rentals.products.price_group' | translate }}:
        </div>
        <div class="col-md-8 value">
          <p-dropdown [options]="priceGroupOptions" [(ngModel)]="product.priceGroupID">
          </p-dropdown>
        </div>
      </div>
    </div>


    <div class="info-container content">
      <div class="row" *ngIf="product.imageURL">
        <div class="col-md-12 margin-bottom-16">
          <div class="primary-image" [ngClass]="{ 'primary-image-loading' : uploadingPrimaryImage}"
            [ngStyle]="{'background-image': 'url('+product.imageURL+'), linear-gradient(0deg, white 0%, white 100%)'}">
          </div>
          <div class="primary-image-overlay" *ngIf="uploadingPrimaryImage">
            <p-progressSpinner [style]="{ width: '30px', height: '30px' }" animationDuration=".5s"></p-progressSpinner>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-3"></div>
        <div class="col-md-6">
          <button pButton class="p-button full-width"
            [ngClass]="{'alternate':product.imageURL,'accent':!product.imageURL}"
            label="{{'bikeshop.rentals.products.upload_primary_image' | translate}}" [disabled]="uploadingPrimaryImage"
            (click)="primaryUpload.click()"></button>
          <input #primaryUpload type="file" style="display: none" (change)="primaryUploader($event)">
        </div>
        <div class="col-md-3"></div>
      </div>
    </div>

    <div class="info-container content">
      <div class="row">
        <div class="col-md-4 label" [ngClass]="{'red bold': !product.isRental && !product.isDemo}">
          {{ 'bikeshop.rentals.products.product_type' | translate }}:
        </div>
        <div class="col-md-8 value">
          <div class="status-container">
            <div [ngClass]="{'ready' : product.isRental == true}" (click)="product.isRental = !product.isRental">
              {{'bikeshop.rentals.products.rental_product' | translate}}</div>
            <div [ngClass]="{'ready' : product.isDemo == true}" (click)="product.isDemo = !product.isDemo">
              {{'bikeshop.rentals.products.demo_product' | translate}}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="info-container content">
      <div class="row">
        <div class="col-md-4 label">
          {{ 'bikeshop.rentals.products.status' | translate }}:
        </div>
        <div class="col-md-8 value">
          <div class="status-container">
            <div [ngClass]="{'draft' : product.statusID === 1}" (click)="product.statusID = 1">
              {{'bikeshop.rentals.products.draft' | translate}}</div>
            <div [ngClass]="{'ready' : product.statusID === 10}" (click)="product.statusID = 10">
              {{'bikeshop.rentals.products.ready_for_rental' | translate}}</div>
            <div [ngClass]="{'repair' : product.statusID === 40}" (click)="product.statusID = 40"
              *ngIf="product && product.id">
              {{'bikeshop.rentals.products.repair_needed' | translate}}</div>
          </div>
        </div>
      </div>
    </div>


    <div class="margin-top-16 button-container">
      <div class="row margin-bottom-16" *ngIf="!isValid()">
        <div class="col-md-12">
          <div class="red bold" style="font-size: 16px; text-align: right;">{{
            'bikeshop.rentals.products.validation_message' | translate }}</div>
        </div>
      </div>
      <div style="display: flex; justify-content: space-between;">
        <div style="display: flex;">
          <div *ngIf="editing" style="margin-right: 20px;">
            <button *ngIf="!retiring" pButton label="{{'bikeshop.rentals.products.retire_rental_product' | translate}}"
              class="p-button-raised alternate" (click)="retireRentalProduct()" [disabled]="savingRentalProduct"
              style="width: 200px;"></button>
            <div *ngIf="retiring">
              <p-progressSpinner [style]="{ width: '30px', height: '30px' }" animationDuration=".5s">
              </p-progressSpinner>
            </div>
          </div>
        </div>
        <button *ngIf="!savingRentalProduct" pButton (click)="saveRentalProduct()" class="p-button-raised"
          label="{{'bikeshop.general.save' | translate}}" [disabled]="retiring || uploadingPrimaryImage || !isValid()"
          style="width: 200px;"></button>
        <div *ngIf="savingRentalProduct">
          <p-progressSpinner [style]="{ width: '30px', height: '30px' }" animationDuration=".5s"></p-progressSpinner>
        </div>
      </div>
    </div>

  </div>
</div>

<div class="container-fluid" *ngIf="!loading && selectedTab===1">
  <!-- <div class="product-title">{{product.brand}} {{product.model}} {{product.color}} {{product.size}} {{product.serialNumber}}</div> -->
  <div class="info-container content">
    <div style="display: flex; justify-content: flex-end; gap: 16px;">
      <div></div>
      <div>
        <button pButton (click)="showAddServiceIndicatorEvent = true" class="p-button-raised"
          *ngIf="productServiceIndicatorConfig && productServiceIndicatorConfig.serviceIndicatorsConfigured && productServiceIndicatorConfig.serviceIndicatorID > 0"
          label="{{'bikeshop.rentals.products.add_usage_entry' | translate}}"
          [disabled]="showAddServiceIndicatorEvent || showCreateServiceIndicatorServiceEvent || showSnoozeServiceIndicatorEvent"
          style="width: 200px;"></button>
      </div>
      <div>
        <button pButton (click)="scheduleService()" 
          class="p-button-raised"
          *ngIf="hasWorkShopSubscription"
          label="{{'bikeshop.modal.shedule_service.schedule_service' | translate}}"
          [disabled]="preparingToBookService || showAddServiceIndicatorEvent || showCreateServiceIndicatorServiceEvent || showSnoozeServiceIndicatorEvent"
          style="width: 200px;"></button>
      </div>
    </div>
    <!-- <div *ngIf="!loadingServiceHistory && serviceHistory.length === 0 && !preparingToBookService && !serviceSlotError">
      <div class="no-service-history">{{ 'bikeshop.rentals.products.no_service_history' | translate }}</div>
    </div> -->
    <div *ngIf="preparingToBookService">
      <div style="margin-top: 32px;display: flex;justify-content: center; margin-bottom: 16px;">
        <p-progressSpinner [style]="{ width: '30px', height: '30px' }" animationDuration=".5s">
        </p-progressSpinner>
      </div>
      <div class="prepare-service-booking">{{ 'bikeshop.rentals.products.preparing_to_book_service' | translate }}</div>
    </div>
    <div class="no-service-history bold margin-top-16" *ngIf="serviceSlotError && !preparingToBookService">
      {{ 'bikeshop.rentals.products.error_getting_service_slot' | translate }}
    </div>
  </div>

  <div class="info-container content"
    *ngIf="productServiceIndicatorConfig && productServiceIndicatorConfig.serviceIndicatorsConfigured && showAddServiceIndicatorEvent">
    <div class="section-title">{{ 'bikeshop.rentals.products.add_usage_entry' | translate }}</div>
    <div class="label">{{ 'bikeshop.rentals.products.add_usage_entry_description' | translate }}</div>

    <div class="row margin-top-8"
      *ngIf="productServiceIndicatorDetailedConfig && productServiceIndicatorDetailedConfig.length > 1">
      <div class="col-md-4 label">
        {{ 'bikeshop.rentals.products.select_component' | translate }}:
      </div>
      <div class="col-md-8 value">
        <p-dropdown [options]="productServiceIndicatorDetailedConfig" optionLabel="component"
          [(ngModel)]="selectedServiceIndicatorComponent"></p-dropdown>
      </div>
    </div>
    <div class="row margin-top-8" *ngIf="selectedServiceIndicatorComponent">
      <div class="col-md-4 label">
        {{ 'bikeshop.rentals.products.usage_value' | translate }}:
      </div>
      <div class="col-md-8 value">
        <div class="p-inputgroup">
          <input type="number" pInputText [(ngModel)]="selectedServiceIndicatorComponent.valueApplied" placeholder="{{selectedServiceIndicatorComponent.metric === 'Mileage' ? translate.instant('bikeshop.rentals.products.enter_current_mileage') : 
                        selectedServiceIndicatorComponent.metric === 'Hours' ? translate.instant('bikeshop.rentals.products.enter_current_hours') :
                        selectedServiceIndicatorComponent.metric === 'TimeIntervalDays' ? translate.instant('bikeshop.rentals.products.enter_days') :
                        selectedServiceIndicatorComponent.metric === 'RentalCount' ? translate.instant('bikeshop.rentals.products.enter_rental_count') : 
                        selectedServiceIndicatorComponent.metric === 'Points' ? translate.instant('bikeshop.rentals.products.enter_points') : ''
                        }}">
          <span class="p-inputgroup-addon">
            {{selectedServiceIndicatorComponent.metric === 'Mileage' ?
            (partnerData.DefaultUnitOfMeasure == 1 ? 'Kms' : 'Miles') :
            selectedServiceIndicatorComponent.metric === 'Hours' ?
            translate.instant('bikeshop.rentals.booking.hours') :
            selectedServiceIndicatorComponent.metric === 'TimeIntervalDays' ?
            translate.instant('bikeshop.rentals.booking.days') :
            selectedServiceIndicatorComponent.metric === 'RentalCount' ?
            translate.instant('bikeshop.rentals.booking.reservations') :
            selectedServiceIndicatorComponent.metric === 'Points' ?
            translate.instant('bikeshop.rentals.booking.points') : ''
            }}
          </span>
        </div>
      </div>
    </div>
    <div class="row margin-top-8" *ngIf="selectedServiceIndicatorComponent">
      <div class="col-md-4 label">
        {{ 'bikeshop.rentals.products.select_usage_date' | translate }}:
      </div>
      <div class="col-md-8 value">
        <p-calendar [(ngModel)]="selectedServiceIndicatorComponent.eventDate" [showTime]="true" [maxDate]="currentDate" />
      </div>
    </div>
    <div style="margin-top: 8px;display: flex; justify-content: space-between;">
      <div>
        <button pButton (click)="showAddServiceIndicatorEvent = false" class="p-button-raised alternate"
          label="{{'general.cancel' | translate}}" style="width: 200px;"></button>
      </div>
      <div>
        <button pButton (click)="saveServiceIndicatorUsageEvent()" class="p-button-raised accent"
          label="{{'bikeshop.rentals.products.save_usage' | translate}}"
          [disabled]="!selectedServiceIndicatorComponent || !selectedServiceIndicatorComponent.valueApplied || savingServiceIndicatorEvent"
          style="width: 200px;"></button>
      </div>
    </div>

  </div>

  <div class="info-container content"
    *ngIf="productServiceIndicatorConfig && productServiceIndicatorConfig.serviceIndicatorsConfigured && showSnoozeServiceIndicatorEvent">
    <div class="section-title">{{ 'bikeshop.rentals.products.snooze_service_indicator_warning' | translate }}</div>

    <div class="row margin-top-8"
      *ngIf="selectedSnoozeServiceIndicatorComponent && selectedSnoozeServiceIndicatorComponent.component">
      <div class="col-md-4 label">
        {{ 'bikeshop.rentals.service_indicators_config.component_name' | translate }}:
      </div>
      <div class="col-md-8 value">
        {{selectedSnoozeServiceIndicatorComponent.component}}
      </div>
    </div>
    <div class="row margin-top-8" *ngIf="selectedSnoozeServiceIndicatorComponent">
      <div class="col-md-4 label">
        {{ 'bikeshop.rentals.products.snooze_by' | translate }}:
      </div>
      <div class="col-md-8 value">
        <div class="p-inputgroup">
          <input type="number" pInputText [(ngModel)]="selectedSnoozeServiceIndicatorComponent.valueApplied">
          <span class="p-inputgroup-addon">
            {{selectedSnoozeServiceIndicatorComponent.metric === 'Mileage' ?
            (partnerData.DefaultUnitOfMeasure == 1 ? 'Kms' : 'Miles') :
            selectedSnoozeServiceIndicatorComponent.metric === 'Hours' ?
            translate.instant('bikeshop.rentals.booking.hours') :
            selectedSnoozeServiceIndicatorComponent.metric === 'TimeIntervalDays' ?
            translate.instant('bikeshop.rentals.booking.days') :
            selectedSnoozeServiceIndicatorComponent.metric === 'RentalCount' ?
            translate.instant('bikeshop.rentals.booking.reservations') :
            selectedSnoozeServiceIndicatorComponent.metric === 'Points' ?
            translate.instant('bikeshop.rentals.booking.points') : ''
            }}
          </span>
        </div>
      </div>
    </div>

    <div style="margin-top: 8px;display: flex; justify-content: space-between;">
      <div>
        <button pButton (click)="showSnoozeServiceIndicatorEvent = false" class="p-button-raised alternate"
          label="{{'general.cancel' | translate}}" style="width: 200px;"></button>
      </div>
      <div>
        <button pButton (click)="saveSnoozeServiceIndicatorUsageEvent()" class="p-button-raised accent"
          label="{{'bikeshop.rentals.products.snooze_indicator' | translate}}"
          [disabled]="!selectedSnoozeServiceIndicatorComponent || !selectedSnoozeServiceIndicatorComponent.valueApplied || savingServiceIndicatorEvent"
          style="width: 200px;"></button>
      </div>
    </div>

  </div>

  <div class="info-container content"
    *ngIf="productServiceIndicatorConfig && productServiceIndicatorConfig.serviceIndicatorsConfigured && showCreateServiceIndicatorServiceEvent">
    <div class="section-title">{{ 'bikeshop.rentals.products.mark_service_indicator_as_serviced' | translate }}</div>

    <div class="row margin-top-8"
      *ngIf="selectedServiceIndicatorServiceEventComponent && selectedServiceIndicatorServiceEventComponent.component">
      <div class="col-md-4 label">
        {{ 'bikeshop.rentals.service_indicators_config.component_name' | translate }}:
      </div>
      <div class="col-md-8 value">
        {{selectedServiceIndicatorServiceEventComponent.component}}
      </div>
    </div>
    <div class="row margin-top-8" *ngIf="selectedServiceIndicatorServiceEventComponent">
      <div class="col-md-4 label">
        {{ 'bikeshop.rentals.products.select_date_serviced' | translate }}:
      </div>
      <div class="col-md-8 value">
        <div class="p-inputgroup">
          <p-calendar [showTime]="true" [(ngModel)]="selectedServiceIndicatorServiceEventComponent.serviceDate" [maxDate]="currentDate"  />
        </div>
      </div>
    </div>
    <div class="row margin-top-8" *ngIf="selectedServiceIndicatorServiceEventComponent">
      <div class="col-md-4 label">
        {{ 'bikeshop.rentals.products.notes' | translate }}:
      </div>
      <div class="col-md-8 value">
        <div class="p-inputgroup">
          <input type="text" pInputText [(ngModel)]="selectedServiceIndicatorServiceEventComponent.notes" />
        </div>
      </div>
    </div>

    <div style="margin-top: 8px;display: flex; justify-content: space-between;">
      <div>
        <button pButton (click)="showCreateServiceIndicatorServiceEvent = false" class="p-button-raised alternate"
          label="{{'general.cancel' | translate}}" style="width: 200px;"></button>
      </div>
      <div>
        <button pButton (click)="saveServiceIndicatorServiceEvent()" class="p-button-raised accent accent"
          label="{{'bikeshop.rentals.products.save_service_indicator_service' | translate}}"
          [disabled]="!selectedServiceIndicatorServiceEventComponent || !selectedServiceIndicatorServiceEventComponent.serviceDate || savingServiceIndicatorEvent"
          style="width: 200px;"></button>
      </div>
    </div>

  </div>

  <div *ngIf="getWorkshopServiceHistory().length > 0">
    <div class="info-container content service-container" *ngFor="let service of getWorkshopServiceHistory()">
      <div class="title">#{{service.JobCardNo}}</div>
      <div class="record-row">
        <div class="label">{{ 'bikeshop.rentals.products.service_at' | translate }}:</div>
        <div class="value">{{service.PartnerDescription}}</div>
      </div>
      <div class="record-row">
        <div class="label">{{ 'bikeshop.modal.shared.bike.service_date' | translate }}:</div>
        <div class="value">{{service.DateCheckedIn | date : countryData.AngularDateFormat}}</div>
      </div>
      <div class="record-row">
        <div class="label">{{ 'general.headers.technician' | translate }}:</div>
        <div class="value">{{ service.TechnicianDescription }}</div>
      </div>
      <div class="record-row">
        <div class="label">{{ 'general.headers.status' | translate }}:</div>
        <div class="value">{{ getStatusDescription(service) }}</div>
      </div>
      <div class="record-row">
        <div class="label">{{ 'bikeshop.modal.shared.bike.service_information' | translate }}:</div>
        <div class="value">{{service.TypeDescription}}</div>
      </div>
      <div style="display: flex;justify-content: space-between; margin-top: 16;">
        <div></div>
        <button pButton (click)="openJobCard(service)" class="p-button-raised alternate"
                label="{{'bikeshop.rentals.products.open_job_card' | translate}}"></button>
      </div>
    </div>
  </div>

  <div class="info-container content" *ngIf="!loadingServiceHistory && (serviceIndicatorHistory.length === 0 && getWorkshopServiceHistory().length === 0) && !preparingToBookService && !serviceSlotError">
      <div class="no-service-history">{{ 'bikeshop.rentals.products.no_service_history' | translate }}</div>
  </div>

  <div #serviceHistory class="info-container content"
    *ngIf="!loadingServiceHistory && serviceIndicatorHistory.length > 0 && !showAddServiceIndicatorEvent && !showSnoozeServiceIndicatorEvent && !showCreateServiceIndicatorServiceEvent">

    <div class="section-title">{{ 'bikeshop.rentals.products.service_history_title' | translate }}</div>

    <div class="service-timeline-container">
      <div class="service-timeline">

        <!-- Never Serviced Items -->
        <ng-container *ngFor="let item of serviceIndicatorHistory">
          <ng-container *ngIf="item.periodType === 'NEVER_SERVICED'">
            <div class="timeline-item">
              <div class="timeline-marker" [ngClass]="{
                      'status-good' : item.indicatorStatus >= 0 && item.indicatorStatus < HEALTHY_THRESHOLD,
                      'status-warning' : item.indicatorStatus >= HEALTHY_THRESHOLD && item.indicatorStatus < CRITICAL_THRESHOLD,
                      'status-attention' : item.indicatorStatus >= CRITICAL_THRESHOLD && item.indicatorStatus < SERVICE_DUE_THRESHOLD,
                      'status-critical' : item.indicatorStatus >= SERVICE_DUE_THRESHOLD,
                    }">
                <i class="timeline-icon">●</i>
              </div>
              <div class="timeline-content">
                <div class="timeline-header">
                  <div class="header-main">
                    <span class="timeline-title">{{ item.serviceIndicatorName }}<span *ngIf="item.component"> - {{
                        item.component }}</span></span>
                    <span class="timeline-badge" [ngClass]="{
                      'status-good' : item.indicatorStatus >= 0 && item.indicatorStatus < HEALTHY_THRESHOLD,
                      'status-warning' : item.indicatorStatus >= HEALTHY_THRESHOLD && item.indicatorStatus < CRITICAL_THRESHOLD,
                      'status-attention' : item.indicatorStatus >= CRITICAL_THRESHOLD && item.indicatorStatus < SERVICE_DUE_THRESHOLD,
                      'status-critical' : item.indicatorStatus >= SERVICE_DUE_THRESHOLD,
                    }">{{getStatusLabel(item.indicatorStatus)}}</span>
                  </div>
                </div>
                <div class="timeline-body">
                  <div class="service-info">
                    <div class="service-details-row">
                      <div class="detail-item">
                        <span class="detail-text"><span class="bold">{{ getMetricLabel(item.metric) }}:</span> {{
                          item.pointsAccumulated | number:'1.1-1' }}
                          {{getMetricValueLabel(item.metric,item.pointsAccumulated)}}
                          {{'bikeshop.rentals.service_indicators_config.accumulated' | translate}}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="status-indicator-container">
                  <div class="status-bar">
                    <div class="status-fill" [ngClass]="getStatusClass(item.indicatorStatus)"
                      [style.width.%]="getStatusPercentage(item.indicatorStatus)"></div>
                  </div>
                  <span class="status-text">{{ item.pointsAccumulated.toFixed(0) }} {{
                    'bikeshop.rentals.service_indicator_status_report.of' | translate }} {{ item.serviceThreshold }} =
                    {{item.indicatorStatus.toFixed(1)}}%</span>
                </div>

                <div class="service-indicator-button-container" *ngIf="item.indicatorStatus >= SERVICE_DUE_THRESHOLD">
                  <button pButton (click)="snoozeServiceIndicator(item)" class="p-button-raised accent"
                    label="{{'bikeshop.rentals.products.snooze_service_indicator_warning' | translate}}"></button>
                  <button pButton (click)="createServiceIndicatorServiceEvent(item)" class="p-button-raised accent"
                    label="{{'bikeshop.rentals.products.mark_service_indicator_as_serviced' | translate}}"></button>
                </div>
              </div>
            </div>
          </ng-container>
        </ng-container>


        <!-- Current Status (After Last Service) -->
        <ng-container *ngFor="let item of serviceIndicatorHistory">
          <ng-container *ngIf="item.periodType === 'AFTER_LAST_SERVICE'">
            <div class="timeline-item">
              <div class="timeline-marker" [ngClass]="{
                      'status-good' : item.indicatorStatus >= 0 && item.indicatorStatus < HEALTHY_THRESHOLD,
                      'status-warning' : item.indicatorStatus >= HEALTHY_THRESHOLD && item.indicatorStatus < CRITICAL_THRESHOLD,
                      'status-attention' : item.indicatorStatus >= CRITICAL_THRESHOLD && item.indicatorStatus < SERVICE_DUE_THRESHOLD,
                      'status-critical' : item.indicatorStatus >= SERVICE_DUE_THRESHOLD,
                    }">
                <i class="timeline-icon">●</i>
              </div>
              <div class="timeline-content">
                <div class="timeline-header">
                  <div class="header-main">
                    <span class="timeline-title">{{ item.serviceIndicatorName }}<span *ngIf="item.component"> - {{
                        item.component }}</span></span>
                    <span class="timeline-badge" [ngClass]="{
                      'status-good' : item.indicatorStatus >= 0 && item.indicatorStatus < HEALTHY_THRESHOLD,
                      'status-warning' : item.indicatorStatus >= HEALTHY_THRESHOLD && item.indicatorStatus < CRITICAL_THRESHOLD,
                      'status-attention' : item.indicatorStatus >= CRITICAL_THRESHOLD && item.indicatorStatus < SERVICE_DUE_THRESHOLD,
                      'status-critical' : item.indicatorStatus >= SERVICE_DUE_THRESHOLD,
                    }">{{getStatusLabel(item.indicatorStatus)}}</span>
                  </div>
                  <div class="timeline-date">Since {{ formatDate(item.prevServiceDate) }}</div>
                </div>
                <div class="timeline-body">
                  <div class="service-info">
                    <div class="service-details-row">
                      <div class="detail-item">
                        <span class="detail-text"><span class="bold">{{ getMetricLabel(item.metric) }}:</span> {{
                          item.pointsAccumulated | number:'1.1-1' }} {{getMetricValueLabel(item.metric,
                          item.pointsAccumulated)}} {{'bikeshop.rentals.service_indicators_config.accumulated' |
                          translate}}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="status-indicator-container">
                  <div class="status-bar">
                    <div class="status-fill" [ngClass]="getStatusClass(item.indicatorStatus)"
                      [style.width.%]="getStatusPercentage(item.indicatorStatus)"></div>
                  </div>
                  <span class="status-text">{{ item.pointsAccumulated.toFixed(0) }} {{
                    'bikeshop.rentals.service_indicator_status_report.of' | translate }} {{ item.serviceThreshold }} =
                    {{item.indicatorStatus.toFixed(1)}}%</span>
                </div>
                <div class="service-indicator-button-container" *ngIf="item.indicatorStatus >= SERVICE_DUE_THRESHOLD">
                  <button pButton (click)="snoozeServiceIndicator(item)" class="p-button-raised accent"
                    label="{{'bikeshop.rentals.products.snooze_service_indicator_warning' | translate}}"></button>
                  <button pButton (click)="createServiceIndicatorServiceEvent(item)" class="p-button-raised accent"
                    label="{{'bikeshop.rentals.products.mark_service_indicator_as_serviced' | translate}}"></button>
                </div>
              </div>
            </div>
          </ng-container>
        </ng-container>



        <!-- Between Services Items - Sorted by service date descending -->
        <ng-container *ngFor="let item of getSortedServiceHistory()">
          <ng-container *ngIf="item.periodType === 'BETWEEN_SERVICES'">
            <!-- Service Event -->
            <div class="timeline-item">
              <div class="timeline-marker service-marker">
                <i class="timeline-icon">●</i>
              </div>
              <div class="timeline-content">
                <div class="timeline-header">
                  <div class="header-main">
                    <span class="timeline-title">{{ 'bikeshop.rentals.products.service_completed' | translate }}</span>
                    <span class="timeline-badge service">{{ 'bikeshop.rentals.products.serviced' | translate }}</span>
                  </div>
                  <div class="timeline-date">{{ formatDate(item.serviceDate) }}</div>
                </div>
                <div class="timeline-body">
                  <div class="service-info">
                    <div class="service-indicator">{{ item.serviceIndicatorName }}<span *ngIf="item.component"> - {{
                        item.component }}</span></div>
                    <div class="service-notes">{{ item.notes }}</div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Points Accumulated Between Services -->
            <div class="timeline-item usage-item">
              <div class="timeline-marker points-marker">
                <i class="timeline-icon small-icon">○</i>
              </div>
              <div class="timeline-content" style="background-color: #f5f5f5;">
                <div class="timeline-header">
                  <div class="header-main">
                    <span class="timeline-title">{{ 'bikeshop.rentals.products.usage_period' | translate }}</span>
                  </div>
                  <div class="timeline-date" *ngIf="isValidDate(item.prevServiceDate)">
                    {{ formatDate(item.prevServiceDate) }} - {{ formatDate(item.serviceDate) }}
                  </div>
                </div>
                <div class="timeline-body">
                  <div class="service-info">
                    <div class="service-indicator">{{ item.serviceIndicatorName }}<span *ngIf="item.component"> - {{
                        item.component }}</span></div>
                    <div class="service-details-row">
                      <div class="detail-item">
                        <span class="detail-text"><span class="bold">{{ getMetricLabel(item.metric) }}:</span> {{
                          item.pointsAccumulated | number:'1.1-1' }} {{getMetricValueLabel(item.metric,
                          item.pointsAccumulated)}}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
        </ng-container>

      </div>
    </div>
  </div>




</div>

<div class="container-fluid" *ngIf="!loading && selectedTab===2">
  <div class="info-container content">
    <div class="label">{{ 'bikeshop.rentals.products.move_product_info' | translate }}</div>

    <div *ngIf="moveData.futureBookings && moveData.futureBookings.length > 0" class="future-booking-error">
      {{ 'bikeshop.rentals.products.move_product_future_bookings' | translate }}
    </div>

    <div *ngIf="moveData.futureBookings && moveData.futureBookings.length === 0">

      <div class="row margin-top-8">
        <div class="col-md-4 label" [ngClass]="{'red bold': moveDataInput.destinationPartnerID === 0 }">
          {{ 'bikeshop.rentals.products.select_destination_store' | translate }}:
        </div>
        <div class="col-md-8 value">
          <p-dropdown [options]="moveData.stores" [(ngModel)]="moveDataInput.destinationPartnerID"
            [disabled]="movingProduct || productMoved" [autoDisplayFirst]="false" (onChange)="storeSelected($event)">
          </p-dropdown>
        </div>
      </div>

      <div class="row margin-top-8">
        <div class="col-md-4 label" [ngClass]="{'red bold': moveDataInput.categoryID === 0 }">
          {{ 'bikeshop.rentals.products.category' | translate }}:
        </div>
        <div class="col-md-8 value">
          <p-dropdown [options]="moveDataCategories" [(ngModel)]="moveDataInput.categoryID" [autoDisplayFirst]="false"
            [disabled]="moveDataCategories.length === 0 || movingProduct || productMoved">
          </p-dropdown>
        </div>
      </div>

      <div class="row margin-top-8">
        <div class="col-md-4 label" [ngClass]="{'red bold': moveDataInput.priceGroupID === 0 }">
          {{ 'bikeshop.rentals.products.price_group' | translate }}:
        </div>
        <div class="col-md-8 value">
          <p-dropdown [options]="moveDataPriceGroups" [(ngModel)]="moveDataInput.priceGroupID"
            [autoDisplayFirst]="false" [disabled]="moveDataPriceGroups.length === 0 || movingProduct || productMoved">
          </p-dropdown>
        </div>
      </div>

      <div *ngIf="movingProduct" style="margin-top: 16px;display: flex;justify-content: center;">
        <p-progressSpinner [style]="{ width: '30px', height: '30px' }" animationDuration=".5s">
        </p-progressSpinner>
      </div>

      <div class="row margin-top-16" *ngIf="!productMoved && !movingProduct">
        <div class="col-md-7"></div>
        <div class="col-md-5">
          <button pButton class="p-button full-width" [disabled]="!productMoveValid() || movingProduct || productMoved"
            label="{{ 'bikeshop.rentals.products.move_product'| translate }}" (click)="moveRentalProduct()"></button>
        </div>
      </div>


    </div>

  </div>
</div>

<div class="container-fluid" *ngIf="!loading && selectedTab===3">
  <div class="info-container content">

    <div class="label">
      {{ 'bikeshop.rentals.products.block_product_description' | translate }}
    </div>

    <div class="row margin-top-16">
      <div class="col-md-4 label" [ngClass]="{'red bold': blockingDataInput.description.length === 0}">
        {{ 'bikeshop.rentals.products.block_product.form.description' | translate }}:
      </div>
      <div class="col-md-8 value">
        <input type="text" pInputText [(ngModel)]="blockingDataInput.description" />
      </div>
    </div>

    <div class="row margin-top-8">
      <div class="col-md-4 label" [ngClass]="{'red bold': blockingDataInput.startDateTime == null}">
        {{ 'bikeshop.rentals.products.block_product.form.startdatetime' | translate }}:
      </div>
      <div class="col-md-8 value">

        <!-- start date time picker -->
        <div class="input-icon-right">
          <p-calendar [minDate]="today" [dateFormat]="countryData.DatePickerFormat"
            hourFormat="{{setCalendarTimeFormat}}" [hideOnDateTimeSelect]="true" [showTime]="true" [stepMinute]="1"
            [readonlyInput]="true" [(ngModel)]="blockingDataInput.startDateTime"></p-calendar>
          <i class="fa fa-calendar"></i>
        </div>
        <!-- end date time picker -->

      </div>
    </div>

    <div class="row margin-top-8">
      <div class="col-md-4 label"
        [ngClass]="{'red bold': blockingDataInput.endDateTime == null || (blockingDataInput.endDateTime < blockingDataInput.startDateTime)}">
        {{ 'bikeshop.rentals.products.block_product.form.enddatetime' | translate }}:
      </div>
      <div class="col-md-8 value">

        <!-- start date time picker -->
        <div class="input-icon-right">
          <p-calendar [minDate]="blockingDataInput.startDateTime" [dateFormat]="countryData.DatePickerFormat"
            hourFormat="{{setCalendarTimeFormat}}" [hideOnDateTimeSelect]="true" [showTime]="true" [stepMinute]="1"
            [readonlyInput]="true" [(ngModel)]="blockingDataInput.endDateTime"></p-calendar>
          <i class="fa fa-calendar"></i>
        </div>
        <!-- end date time picker -->

      </div>
    </div>

    <div *ngIf="blockingProduct" style="margin-top: 16px;display: flex;justify-content: center;">
      <p-progressSpinner [style]="{ width: '30px', height: '30px' }" animationDuration=".5s">
      </p-progressSpinner>
    </div>

    <div class="row margin-top-16" *ngIf="!blockingProduct">
      <div class="col-md-2"></div>
      <div class="col-md-5">
        <button *ngIf="showCancelBlockProduct" pButton type="button" class="p-button-raised full-width alternate"
          label="{{ 'bikeshop.rentals.products.block_product_cancelbutton'| translate }}"
          (click)="cancelRentalProductBlock()"></button>
      </div>
      <div class="col-md-5">
        <button pButton class="p-button full-width" [disabled]="!productBlockValid() || blockingProduct"
          label="{{ 'bikeshop.rentals.products.block_product_savebutton'| translate }}"
          (click)="blockRentalProduct()"></button>
      </div>
    </div>

  </div>

  <div class="info-container content">

    <div class="blocked-items-container">
      <div class="header row">
        <div class="col-5">{{ 'bikeshop.rentals.products.block_product.header.event' | translate }}</div>
        <div class="col-5">{{ 'bikeshop.rentals.products.block_product.header.date' | translate }}</div>
        <div class="col-2"></div>
      </div>

      <div *ngFor="let item of blockProductData" class="row">
        <!--Start Display Row-->

        <div class="col-5 text-left">
          {{ item.description }}
        </div>
        <div class="col-5 text-left">
          {{ (item.startDateTime | date: countryData.AngularDateFormat) + ' ' + (item.startDateTime | date: 'h:mma') }}
          -
          {{ (item.endDateTime | date: countryData.AngularDateFormat) + ' ' + (item.endDateTime | date: 'h:mma') }}
        </div>
        <div class="col-2 actions text-right">
          <span class="fa fa-fw hubtiger-edit" style="font-size:24px; margin-right: 8px;"
            (click)="editRentalProductBlock(item)" title="Edit item.">
          </span>

          <span class="fa fa-fw hubtiger-delete" style="font-size:24px;" (click)="deleteRentalProductBlock(item)"
            title="Delete item.">
          </span>
        </div>
        <!--End Display Row-->
      </div>
    </div>

  </div>
</div>

<p-confirmDialog key="add_edit_rental_product"></p-confirmDialog>
<p-confirmDialog key="select_service_indicators">
      <ng-template pTemplate="message" let-message>
        <div style="width: 450px;">
          <div class="label">{{ 'bikeshop.rentals.products.select_service_indicator_to_service' | translate}}</div>
          <div class="margin-top-8"></div>
              <div *ngFor="let item of selectedServiceIndicatorsForService" class="row margin-top-8">
                <div class="col-md-1"><p-checkbox [binary]="true" [(ngModel)]="item.selected" /></div>
                <div class="col-md-11 label" [ngClass]="{'red' : item.indicatorStatus >= SERVICE_DUE_THRESHOLD}">{{item.component ? item.component : item.serviceIndicatorName }} - {{item.metric}}</div>
              </div>
        </div>
    </ng-template>
</p-confirmDialog>